import { render, staticRenderFns } from "./ImageBrokenIcon.vue?vue&type=template&id=87ef03de&"
import script from "./ImageBrokenIcon.vue?vue&type=script&lang=js&"
export * from "./ImageBrokenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports